import { Booleanish } from "./types"

export function canUseDom() {
  return !!(
    typeof window !== "undefined" &&
    window.document &&
    window.document.createElement
  )
}

export const ariaAttr = (condition: boolean | undefined) =>
  condition ? true : undefined

export const isBrowser = canUseDom()

export const dataAttr = (condition: boolean | undefined) =>
(condition ? "" : undefined) as Booleanish
